const FloatingImageTypes = {
  LEFT: 'left',
  RIGHT: 'right',
};

module.exports = FloatingImageTypes;
